module.exports = __webpack_public_path__ + "static/media/tool_proficiency.0b1a5f37.png";


//////////////////
// WEBPACK FOOTER
// ./src/Jiggle/Design/img/tool_proficiency.png
// module id = 274
// module chunks = 0